import React from 'react';
import styled, {css} from 'styled-components';
import {useIsMobile} from '../../../styles';
import BottomBlob from '../../Blob/BottomBlob';
import ButtonShare from '../ButtonShare';

const ComicsHeader = props => {
    const isMobile = useIsMobile();

    if (!isMobile) {
        return (
            <Container>
                <InnerContainer>
                    <ComicImage
                        src={`${props.comic.baseUrl}${props.comic.cover}`}
                        big={!isMobile}
                    />
                    <VStack>
                        <BorderedTitle>
                            {props.comic.show.toUpperCase()}
                        </BorderedTitle>

                        <TitleText size={36} big={!isMobile}>
                            {props.comic.title}
                        </TitleText>
                        <BorderedTitle comic={props.comic} />
                        <ButtonShare comic={props.comic} />
                    </VStack>
                </InnerContainer>
                <BottomBlob />
            </Container>
        );
    } else {
        return (
            <Container>
                <SimpleBlob />
                <ComicImage
                    src={`${props.comic.baseUrl}${props.comic.cover}`}
                    big={!isMobile}
                />
                <BottomBlob />
                <TitleText big={!isMobile}>{props.comic.title}</TitleText>
            </Container>
        );
    }
};

const Container = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: center;
    flex-direction: column;
`;

const InnerContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 40px 0px 60px 0px;
`;

const SimpleBlob = styled.img.attrs({
    src: require('../../../assets/ill_simple_bblob.png'),
})``;

const ComicImage = styled.img`
    height: 365px;
    width: 260px;
    resize-mode: center;
    align-self: center;
    margin-top: -10px;
    ${props =>
        props.big &&
        css`
            align-self: flex-start;
        `}
`;

const TitleText = styled.div`
    font-family: TTNormsProExtraBlack;
    font-size: ${props => props.size || 12}px;
    background-color: black;
    padding: 4px 10px;
    color: white;
    text-transform: uppercase;
    margin-top: 18px;
    z-index: 1;
    ${props =>
        props.big &&
        css`
            margin-top: 0px;
            padding: 0px 0px;
            margin-bottom: 40px;
        `}
`;

const VStack = styled.div`
    flex-direction: column;
    flex: 1;
    max-width: 350px;
    padding: 0px 40px;
`;

const BorderedTitle = styled.div`
    font-family: TTNormsProExtraBlack;
    font-size: 32px;
    height: 900;
    text-shadow: 1px 1px 0 white, -1px 1px 0 white, 1px -1px 0 white,
        -1px -1px 0 white;
    color: #211921;
    text-transform: uppercase;
`;

export default ComicsHeader;
